export const APP_RED = "#831518";
export const APP_BLUE = "#28317E";